import React from "react";
import { withStyles } from "@mui/styles";
import { Popper } from "@mui/material";
export const CustomPopper = withStyles({
  root: {
    width: "fit-content",
    minWidth: 500,
  },
})((props) => <Popper placement="bottom-start" {...props} className={props.classes.root} />);
